/* eslint-disable eqeqeq */
/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 */
import { extend } from 'umi-request';
import { notification } from 'antd';
import { stringify } from 'querystring';
import { SSO_PATH } from '../../config/'
import signal from '@/utils/class/signal';
import { getFormData } from './utils';

import { REQUEST_CHILD_GAME_ID, GAME_ID, SUCCESS_CODE, NEED_DEAL_PARAMS, DATA, IsNeedGameId, IsNeedChildChildGameId, notNeedGameId, notNeedChildGameId } from '@/constant';



// const controller = new AbortController(); // 创建一个控制器
// const { signal } = controller;

const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};






/**
 * 异常处理程序
 */
const errorHandler = (error: { response: Response }): Response => {
  const { response } = error;
  console.log(response)

  if (response && response.status) {
    const errorText = codeMessage[response.status] || response.statusText;
    const { status, url } = response;

    notification.error({
      message: `请求错误 ${status}: ${url}`,
      description: errorText,
    });
  }
  return response;
};




export function dealParams(data: Record<string,any>={},filterList: string[]=NEED_DEAL_PARAMS): {params: Record<string, any>,filterParams: Record<string, any>} {

  if(data instanceof FormData) { 


    return {params:data,filterParams:{}}
  }


  const temp: Record<string,any> = {};
  const filterTemp: Record<string,any> = {}
  Object.keys(data).forEach((key) => {
    if (!filterList.includes(key) && data[key] !== undefined && data[key] !== null && data[key] !== '') {
      temp[key] = data[key]
    } else {
      filterTemp[key] = data[key]
    }
  });

  if(temp[DATA]) {
    const {params:tempParams,filterParams:tempFilterParams} = dealParams(temp.data,filterList)
    return {params:{...temp,[DATA]:tempParams},filterParams:{...filterTemp,...tempFilterParams}}
  }

  return {params:temp,filterParams:filterTemp}
}






/**
 * 配置request请求时的默认参数
 */

const request = extend({
  prefix: '/api',
  // headers:{'Content-Type':'application/x-www-form-urlencoded'},
  errorHandler, // 默认错误处理
  credentials: 'include', // 默认请求是否带上cookie
  timeout: 3600000, // 设置超时时间
});

const requestPack = extend({
  prefix: '/onlinepack',
  // headers:{'Content-Type':'application/x-www-form-urlencoded'},
  errorHandler, // 默认错误处理
  credentials: 'include', // 默认请求是否带上cookie
  timeout: 3600000, // 设置超时时间
});
const arrR = [request]
arrR.forEach((re) => {
  re.use(async (ctx: any, next: any) => { // 中间件 加token | 判断登录状态
    const { req } = ctx;
    // const {prefix} = ctx.req.options;
    // const newUrl = ctx.req.url.replace(`${prefix}`,'/v2');
    // ctx.req.url = `${prefix}${newUrl}`




    const { options } = req;
    if(!options.data) {
      options.data = {}
    }
    options.signal = signal.getController().signal;
    const { data={} } = options;
    console.log('request data:', data);

    const {params,filterParams} = dealParams(data);
    console.log('request params:', params);
    const gameId = sessionStorage.getItem(GAME_ID)
    const childGameId = filterParams[REQUEST_CHILD_GAME_ID]


    const noGameId = !!((ctx.req.options?.headers[IsNeedGameId] && ctx.req.options?.headers[IsNeedGameId] === notNeedGameId))
    const noChildGameId = !!((ctx.req.options?.headers[IsNeedChildChildGameId] && ctx.req.options?.headers[IsNeedChildChildGameId] === notNeedChildGameId))


  
    ctx.req.options.headers = {
      satoken: localStorage.getItem('sToken') || "",
      ...(gameId && !noGameId)?{"X-Game-Id":gameId}:{},
      ...(childGameId !== undefined && childGameId !== null && !noChildGameId)?{"X-Child-Game-Id":childGameId}:{},
      ...ctx.req.options.headers,
    }


    options.data = params;
    if(noChildGameId && childGameId) {
      options.data = {...params,bodyChildGameId:childGameId}
    }

    await next();
    const { res } = ctx;

   
    
    if (res.code !== SUCCESS_CODE && res.tips) {

      if (res.code === 'A0230') {
        localStorage.removeItem('sToken');
        const queryString = stringify({
          targetUrl: window.location.href,
        });
        window.location.href = `${SSO_PATH}/login?${queryString}`
        // history.push('/user/login');
      } else {
        notification.error({
          message: `${res.tips} : ${res.description}`,
        });
      }
    }
  });
})



const arrR2 = [requestPack]

arrR2.forEach((re) => {
  re.use(async (ctx: any, next: any) => { // 中间件 加token | 判断登录状态
    const { req } = ctx;
    const { options } = req;
    options.signal = signal.getController().signal;
    const { data = {} } = options;
    options.data = getFormData(data);
    await next();
    const { res } = ctx;
    if (res.code !== 0 && res.msg) {
      if (res.code != 20001) {
        notification.error({
          message: res.msg,
        });
      }
      // if (res.msg === '用户未登录') {
      //   localStorage.removeItem('sToken');
      //   const queryString = stringify({
      //     targetUrl: window.location.href,
      //   });
      //   window.location.href = `${SSO_PATH}/login?${queryString}`
      //   // history.push('/user/login');
      // }
    }
  });
})



export { codeMessage, requestPack }
export default request;
